import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative min-h-screen flex flex-col lg:flex-row">
      {/* 全宽背景图 — 左右共用，自然融合 */}
      <img
        src="https://readdy.ai/api/search-image?query=Top-down%20flat%20lay%20composition%20of%20modern%20tablet%20displaying%20colorful%20analytics%20dashboard%20surrounded%20by%20arranged%20fashion%20items%20like%20watch%20scarf%20wallet%20and%20leather%20belt%2C%20cream%20linen%20backdrop%20with%20natural%20morning%20sunlight%20casting%20soft%20dimensional%20shadows%2C%20editorial%20minimal%20style%2C%20warm%20oatmeal%20sand%20and%20beige%20palette%2C%20clean%20airy%20atmosphere%2C%20high-end%20product%20photography%20with%20organic%20spacing%2C%20no%20text%20on%20screen&width=1800&height=1200&seq=hero-full-bg-v4&orientation=landscape"
        alt="Hipobuy Spreadsheet - outil de suivi e-commerce"
        title="Hipobuy Spreadsheet suivi e-commerce"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* 暗色叠加层 — 保证左侧文字清晰可读 */}
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/75 via-foreground-950/30 to-foreground-950/10"></div>

      {/* 左侧文字区 */}
      <div className="flex-1 relative z-10 flex flex-col justify-center px-4 md:px-8 lg:px-16 pt-24 pb-12 lg:py-0">
        <div className="max-w-xl">
          <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-[1.08] tracking-tight">
            Hipobuy<br />
            <span className="italic font-semibold">Spreadsheet</span>
          </h1>
          <p className="mt-6 text-base md:text-lg text-background-50/85 leading-relaxed max-w-lg">
            L'outil ultime de suivi e-commerce intelligent. Optimisez votre business avec un système de <strong>hipobuy spreadsheet</strong> conçu pour le suivi produit, l'analyse des ventes et l'automatisation des données e-commerce.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-background-50 text-foreground-950 rounded-md text-sm font-semibold uppercase tracking-wider whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer group"
            >
              Hipobuy Spreadsheet
              <span className="w-7 h-7 rounded-full border-2 border-foreground-950/20 flex items-center justify-center group-hover:border-foreground-950/50 transition-colors">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-accent-500 text-background-50 dark:text-foreground-950 rounded-full text-sm font-semibold uppercase tracking-wider whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-line text-sm"></i>
            </a>
          </div>
          <div className="mt-6">
            <Link
              to="/guide-hipobuy-spreadsheet"
              className="inline-flex items-center gap-2 text-sm text-background-50/70 hover:text-background-50 transition-colors underline underline-offset-4 whitespace-nowrap"
            >
              Lire le guide complet
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
        </div>
      </div>

      {/* 右侧留白 — 展示背景图画面 */}
      <div className="flex-1 relative z-10 min-h-[400px] lg:min-h-screen" />
    </section>
  );
}